import React, { FC } from 'react';

import { BoxProps } from '@chakra-ui/react';

import { InformationAlert } from 'components/DataDisplay';

interface Props extends BoxProps {
  icon: React.ReactNode;
  description: string;
}

export const JITInformationAlert: FC<Props> = props => {
  const { icon, description, ...rest } = props;
  return (
    <InformationAlert
      icon={icon}
      description={description}
      px={3}
      py={2}
      iconSize={6}
      spacing={3}
      border="none"
      bg="#fcf1d3"
      borderRadius={10}
      {...rest}
    />
  );
};
